import { render, staticRenderFns } from "./navigation-link.vue?vue&type=template&id=377fcac8"
import script from "./navigation-link.vue?vue&type=script&lang=js"
export * from "./navigation-link.vue?vue&type=script&lang=js"
import style0 from "./navigation-link.vue?vue&type=style&index=0&id=377fcac8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports